import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { withRouter } from 'react-router';
import I18njs from 'i18n-js';

import Button from 'carbon-react/lib/components/button';
import Loader from 'carbon-react/lib/components/loader';
import Message from 'carbon-react/lib/components/message';
import Textbox from 'carbon-react/lib/components/textbox';

import Translate from '../../components/Translate/Translate';

import * as user from '../../redux/User/actions';

export const ForgotPassword = ({ forgotPassword, history, resetForgotState, user }) => {
  const [username, setUsername] = useState('');
  const [company, setCompany] = useState('');

  const handleSubmit = () => {
    forgotPassword({
      company,
      username: username ? username : user.forgotUsername,
    });
  };

  const returnToLogin = () => {
    resetForgotState();
    history.push('/login');
  };

  return (
    <div className="forgot">
      <div className="card">
        {user.resetSent ? (
          <>
            <div className="title">
              <Translate scope="auth.CheckYourEmail" />
            </div>
            <div className="description">
              <Translate scope="auth.Youllreceiveanemailfrom" />
            </div>
            <div className="description">
              <Translate scope="auth.Cantfindthatemail" />
            </div>
            <div className="description">
              <Translate scope="auth.Ifyoustillcantlogin" />
            </div>
            <div className="footer-div">
              <Button onClick={returnToLogin} className="submit-button" buttonType="primary">
                <Translate scope="auth.ReturntoLogin" />
              </Button>
            </div>
            <div className="footer-div">
              <Button onClick={handleSubmit} className="cancel-button" buttonType="secondary">
                <Translate scope="auth.Resend" />
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="title">
              <Translate scope="auth.ForgotYourPassword" />
            </div>
            <div className="description">
              <Translate scope="auth.Entertheemailasociatedwith" />
            </div>
            <div style={{ marginBottom: 25 }}>
              <Textbox
                id="companyId"
                label={I18njs.t('auth.IntacctCompanyID')}
                name="companyId"
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
                value={company}
              />
              <Textbox
                id="username"
                label={I18njs.t('auth.Username')}
                name="username"
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
                value={username}
              />
            </div>
            {user?.error?.message && (
              <div className="error-wrapper">
                <Message variant="error">{user.error.message}</Message>
              </div>
            )}
            <div className="footer-div">
              <Button buttonType="primary" className="submit-button" key="submit" onClick={handleSubmit}>
                {user.loading ? <Loader isInsideButton /> : <Translate scope="auth.Submit" />}
              </Button>
            </div>
            <div className="footer-div">
              <Button onClick={() => history.push('/login')} className="cancel-button" buttonType="secondary">
                <Translate scope="auth.Cancel" />
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  const _user = bindActionCreators(user, dispatch);
  return {
    forgotPassword: _user.forgotPasswordRequest,
    resetForgotState: _user.resetForgotState,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));
